export const FIRST_NOT_WORKED_DEVICE_FOR_GATE = 'DS06A(P)';
export const SECOND_NOT_WORKED_DEVICE_FOR_GATE = 'DS06A';
